import React from "react";
import { Table, Button, ButtonGroup, Card, CardBody } from "reactstrap";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";

const DateWiseReport: React.FC = () => {
  return (
    <div
      className="p-2"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <PageHeader
        title="Date Wise Report"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      {/* Header */}
      <Card className="shadow-sm">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0">Date wise Report</h5>
            <div className="d-flex gap-2">
              <RoundedDropdown
                options={[]}
                onSelect={(e) => console.log("status", e)}
                defaultLabel="All"
                width="100px"
                isShowHeading
                DropdownHeading="Month"
                headingColor="#2e8dd3"
              />
              <RoundedDropdown
                options={[]}
                onSelect={(e) => console.log("status", e)}
                defaultLabel="All"
                width="100px"
                isShowHeading
                DropdownHeading="Currency"
                headingColor="#2e8dd3"
              />
            </div>
          </div>
          {/* Report Title */}
          <h6 className="text-center mb-4">Date wise Report | March 2025</h6>

          {/* Employee Information Table */}
          <Table borderless>
            <tbody>
              <tr>
                <th>Employee Name</th>
                <td>sachin kadam</td>
              </tr>
              <tr>
                <th>Employee Code</th>
                <td>001</td>
              </tr>
              <tr>
                <th>Designation</th>
                <td>CMD</td>
              </tr>
              <tr>
                <th>State</th>
                <td></td>
              </tr>
              <tr>
                <th>Head Quarter / Location</th>
                <td>Head Office</td>
              </tr>
              <tr>
                <th>Currency</th>
                <td></td>
              </tr>
            </tbody>
          </Table>

          {/* Date-wise Details Table */}
          <Table bordered responsive className="mt-4">
            <thead>
              <tr>
                <th>DATE</th>
                <th>WORKING</th>
                <th>IO</th>
                <th>REQUESTED</th>
                <th>GST</th>
                <th>ADDITIONAL</th>
                <th>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Total</th>
                <td colSpan={6}></td>
              </tr>
              <tr>
                <td colSpan={7} className="text-end">
                  <strong>Signature</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

export default DateWiseReport;
